import * as React from "react";

const IconTableSort: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="11" viewBox="0 0 8 11">
            <path
                fill="currentColor"
                d="M4,0 L0,3.53571429 L0,4.71428571 L8,4.71428571 L8,3.53571429 L4,0 Z M4,11 L8,7.46428571 L8,6.28571429 L0,6.28571429 L0,7.46428571 L4,11 Z"
            />
        </svg>
    );
};

export default React.memo(IconTableSort);
